export const GENERAL_MESSAGE = 'GENERAL_MESSAGE';
export const API_MESSAGE     = 'API_MESSAGE';
export const API_ERROR       = 'API_ERROR';
export const TWO_ACTION      = 'TWO_ACTION';